<script lang="ts">// prettier-ignore
const { as = 'div', isFullWidth = false, children, class: className = '', ...rest } = $props();
export {};
</script>

<svelte:element this={as} {...rest} class="Grid {className}" class:Grid--full-width={isFullWidth}>
  {@render children?.()}
</svelte:element>

<style>@layer design-system-components.pwds {
  .Grid {
    display: grid;
    grid-template-columns: repeat(var(--grid-container-columns), 1fr);
    gap: var(--grid-container-gap);
    width: var(--container-width-current);
    margin-right: var(--space-auto);
    margin-left: var(--space-auto);
  }
  .Grid--full-width {
    width: 100%;
  }
}</style>
